// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3cacd604","732":"6e6d4026","977":"5c9e15d9"}[chunkId] + ".chunk.js";
};